import {ConfigProvider} from '../config/configProvider';

class ReadyProvider
{
    /**
     * @param {CallableFunction} callback
     */
    static executeOnReady(callback) {
        if (document.readyState !== 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    static executeWithLazy(callback) {
        setTimeout(callback, ConfigProvider.get('lazyDelay'));
    }
}

export {ReadyProvider};
